import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-7e0e8eb1")
const _hoisted_1 = {
  key: 0,
  class: "panel-mask"
}
const _hoisted_2 = { class: "panel-wrapper" }
const _hoisted_3 = { class: "panel-body" }
const _hoisted_4 = { class: "panel-title" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "title-body" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title-icon" }),
  /*#__PURE__*/_createElementVNode("div", { class: "title-text" }, "平板控制"),
  /*#__PURE__*/_createElementVNode("div", { class: "title-icon" })
], -1)
const _hoisted_6 = { class: "status-wrapper" }
const _hoisted_7 = { class: "status-item" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "online-icon" }, null, -1)
const _hoisted_9 = { class: "status-item" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "outline-icon" }, null, -1)
const _hoisted_11 = { class: "status-item" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "disabled-icon" }, null, -1)
const _hoisted_13 = { class: "status-item" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "enabled-icon" }, null, -1)
const _hoisted_15 = { class: "list-content" }
const _hoisted_16 = { class: "options-wrapper" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "opt-icon" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "opt-icon-text" }, "集控")
], -1)
_popScopeId()

import { computed, ref } from "vue";
import Socket from "socket.io-client";
import config from "@/config/app.config";
import { DeviceControlEvent } from "./config";
import logger from "@evideo/logger";
import { Close } from "@element-plus/icons-vue";
import deviceCard from "./components/deviceCard.vue";
import vocalBalanceModal from "./components/vocalBalanceModal.vue";
import _ from "lodash";
import {
  DeviceListItem,
  DeviceInfosItem,
  VocalBalance,
  DEFAULT_VOCAL_BALANCE,
} from "./config";
import {
  updateDeviceEnabled,
  batchSetDeviceLogout,
  batchSetDeviceVolume,
  batchSetVocalBalance,
  DEVICE_EVENTS,
} from "./utils";
import optionsBar from "./components/optionsBar.vue";

interface PadControlPanelProps {
  /** 是否展示 */
  visible: boolean;
  onError: () => void;
}

type DeviceCountType = {
  online: number;
  outline: number;
  disabled: number;
  enabled: number;
};


export default _defineComponent({
  props: {
    visible: { type: Boolean, required: true, default: false },
    onError: { type: Function, required: true }
  } as unknown as undefined,
  emits: ["update:visible", "setConnectStatus"] as unknown as undefined,
  setup(__props: {
  /** 是否展示 */
  visible: boolean;
  onError: () => void;
}, { expose, emit }: { emit: ({
  (event: "update:visible", newVal: boolean): void;
  (event: "setConnectStatus", newStatus: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props




// 是否展示面板
const visibleCompu = computed(() => props.visible);

// 统一的设备socket连接对象
const deviceSocket = ref<any | undefined>(undefined);

const DEFALUT_VOLUME = 60;

const showConnectErr = ref<boolean>(false);

const deviceAuth = {
  device_role: "manager",
  device_type: "h5",
  device_info: {
    name: "主控设备:",
    enabled: true,
    device_id: "",
  },
};

const connectLock = ref<Promise<boolean>>();
// 连接成功后解锁
const unlockConnect = ref<any>();

const deviceCount = computed<DeviceCountType>(() => {
  const cfg: DeviceCountType = {
    online: 0,
    outline: 0,
    disabled: 0,
    enabled: 0,
  };
  list.value.forEach((item: DeviceListItem) => {
    if (item.enabled) {
      cfg.enabled += 1;
    } else {
      cfg.disabled += 1;
    }
    if (item.online) {
      cfg.online += 1;
    } else {
      cfg.outline += 1;
    }
  });
  return cfg;
});

// 声音配置
const volume = ref<number>(DEFALUT_VOLUME);
// 人声均衡配置
const vocalBalance = ref<VocalBalance>(DEFAULT_VOCAL_BALANCE);
const list = ref<DeviceListItem[]>([]);

const mute = ref<boolean>(false);
const showVocal = ref<boolean>(false);

// 注册基础事件通知
const registerBaseSocketEvent = (socket: any) => {
  let ipcRenderer;
  let mac;
  if (window && window.require) {
    ipcRenderer = window.require("electron")?.ipcRenderer;
  }
  // mac = ipcRenderer?.sendSync("getMac") || "0:0:0:0";
  mac = ipcRenderer.sendSync("getMac");
  const localMac = localStorage.getItem("mac");
  if (mac) {
    localStorage.setItem("mac", mac);
  } else if (localMac) {
    mac = localMac;
  } else {
    mac = "0:0:0:0";
  }
  mac = mac.toUpperCase().replace(/:/g, "");
  logger.info("local mac", localMac);
  logger.info("mac", mac);
  deviceAuth.device_info.device_id = mac;
  deviceAuth.device_info.name += mac;

  if (!socket) {
    return;
  }

  // 连接后
  socket.on(DeviceControlEvent.CONNECT, () => {
    socket.emit(
      DeviceControlEvent.UPLOAD_DEVICE_INFO,
      deviceAuth,
      (res: any) => {
        console.log("upload device result", res);
        if (typeof unlockConnect.value === "function") {
          unlockConnect.value(true);
          unlockConnect.value = undefined;
        }
      }
    );
    // setTimeout(() => socket.close(), 10000);
  });

  // 断开时
  socket.on(DeviceControlEvent.DISCONNECT, (reason: string) => {
    logger.error("device control service is disconnect", reason);
    if (typeof unlockConnect.value === "function") {
      unlockConnect.value(false);
    }
    if (
      props.onError &&
      typeof props.onError === "function" &&
      showConnectErr.value
    ) {
      props.onError();
    }
  });

  // 断开时
  socket.on(DeviceControlEvent.ERROR, (err: any) => {
    logger.error("device control service is err", err);
    if (typeof unlockConnect.value === "function") {
      unlockConnect.value(false);
    }
  });
};

const registerBizSocketEvent = (socket: any) => {
  if (!socket) {
    return;
  }
  socket.on(DEVICE_EVENTS.UPDATE_DEVICES_INFO, (args: any) => {
    const l = (args.devices || []).map((item: DeviceInfosItem) => {
      return {
        id: item.device_id,
        name: item.device_info.name,
        enabled: item.device_info.enabled,
        online: item.device_info.online,
      };
    });
    list.value = l;
  });

  socket.on(
    DEVICE_EVENTS.BATCH_CONTROL_INFO,
    (info: { config: { volume: number; vocal_balance: any } }) => {
      console.log(info);
      volume.value = info.config.volume;
      vocalBalance.value = info.config.vocal_balance;
    }
  );
};

/**
 * @description 关闭弹窗
 */
const handleClose = () => {
  emit("update:visible", false);
};

/**
 * @description 修改设备新状态
 */
const handleChangeDeviceStatus = (id: string, newEnabled: boolean) => {
  console.log("设备信息");
  updateDeviceEnabled(deviceSocket.value, [id], newEnabled);
};

const handleBatchSetDisabled = () => {
  updateDeviceEnabled(deviceSocket.value, "all", false);
};

const handleBatchSetEnabled = () => {
  updateDeviceEnabled(deviceSocket.value, "all", true);
};

const handleBatchSetLogout = () => {
  batchSetDeviceLogout(deviceSocket.value, "all");
};

const handleBatchSetVolume = (vol: number) => {
  volume.value = vol;
  batchSetDeviceVolume(deviceSocket.value, vol);
};

const handleUpdateMute = (val: boolean) => {
  mute.value = val;
};

const handleVocalBalanceChange = _.throttle((newVocal: VocalBalance) => {
  vocalBalance.value = newVocal;
  batchSetVocalBalance(deviceSocket.value, newVocal);
}, 500);

/**
 * @description 连接socket.io
 * @param port 端口号
 */
const startConnctSocketIO = (port: number) => {
  if (deviceSocket.value !== undefined) {
    return;
  }
  // 设置相关的锁
  connectLock.value = new Promise<boolean>((resolve) => {
    unlockConnect.value = (args: boolean) => {
      resolve(args);
    };
  });

  const uri = `${config["deviceControlService"]}:${port}/pads`;
  deviceSocket.value = Socket(uri, {
    autoConnect: false,
    reconnectionAttempts: 5,
  });
  showConnectErr.value = true;
  registerBaseSocketEvent(deviceSocket.value);
  registerBizSocketEvent(deviceSocket.value);
  deviceSocket.value.connect();

  return connectLock.value;
};

const stopConnectSocketIO = () => {
  showConnectErr.value = false;
  emit("update:visible", false);
  deviceSocket.value?.close();
};

expose({
  startConnect: startConnctSocketIO,
  stopConnect: stopConnectSocketIO,
});

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_unref(visibleCompu))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("h3", {
                class: "close",
                onClick: handleClose
              }, [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Close))
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", null, "在线: " + _toDisplayString(_unref(deviceCount).online), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", null, "离线: " + _toDisplayString(_unref(deviceCount).outline), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("div", null, "已禁用: " + _toDisplayString(_unref(deviceCount).disabled), 1)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("div", null, "已启用: " + _toDisplayString(_unref(deviceCount).enabled), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (device, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass((index + 1) % 5 === 0 ? '' : 'list-item')
                }, [
                  _createVNode(deviceCard, {
                    "device-id": device.id,
                    "device-name": device.name,
                    enabled: device.enabled,
                    online: device.online,
                    onChangeDeviceStatus: handleChangeDeviceStatus
                  }, null, 8, ["device-id", "device-name", "enabled", "online"])
                ], 2))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createVNode(optionsBar, {
              "show-vocal-balance": showVocal.value,
              "onUpdate:show-vocal-balance": _cache[0] || (_cache[0] = ($event: any) => (showVocal.value = $event)),
              volume: volume.value,
              mute: mute.value,
              onSetDisabled: handleBatchSetDisabled,
              onSetEnabled: handleBatchSetEnabled,
              onSetLogout: handleBatchSetLogout,
              onUpdateVolume: handleBatchSetVolume,
              onUpdateMute: handleUpdateMute
            }, null, 8, ["show-vocal-balance", "volume", "mute"])
          ])
        ]),
        _createVNode(vocalBalanceModal, {
          visible: showVocal.value,
          "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (showVocal.value = $event)),
          "vocal-balance": vocalBalance.value,
          onOnChange: _unref(handleVocalBalanceChange),
          class: "vocal-modal-setting"
        }, null, 8, ["visible", "vocal-balance", "onOnChange"])
      ]))
    : _createCommentVNode("", true)
}
}

})